export default "__VITE_ASSET__Bm4$bq3X__"